import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../../../../common/state';
import { EHouseMaterial } from '../../../../../../../json_query';
import { setHouseMaterial } from '../../../../../../state/advanced/house_material';

import { HouseMaterial as HouseMaterialComponent } from './houseMaterial';

export const HouseMaterial = connect(
  (state: IAppState) => ({
    value: (state.filters.jsonQuery.house_material && state.filters.jsonQuery.house_material.value) || [],
  }),
  (dispatch: Dispatch) => ({
    onChange: (value: EHouseMaterial[]) => {
      dispatch(setHouseMaterial(value));
    },
  }),
)(HouseMaterialComponent);
